export const DEFAULT_START_TIME = '00:00:00';
export const DEFAULT_END_TIME = '00:00:00';

export const isFullDay = (startTime, endTime) =>
  startTime === DEFAULT_START_TIME && endTime === DEFAULT_END_TIME;
